import { useState, useEffect } from 'react';

const useNetworkStatus = (onNetworkChange) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const updateNetworkStatus = () => {
      const online = navigator.onLine;
      setIsOnline(online);

      if (onNetworkChange) {
        if (!online && isOnline) {
          // User went offline
          setWasOffline(true);
          onNetworkChange('offline', 'Connexion internet perdue. Vérifiez votre réseau.');
        } else if (online && wasOffline) {
          // User came back online
          setWasOffline(false);
          onNetworkChange('online', 'Connexion internet rétablie!');
        }
      }
    };

    const handleOnline = () => {
      updateNetworkStatus();
    };

    const handleOffline = () => {
      updateNetworkStatus();
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Initial check
    updateNetworkStatus();

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [isOnline, wasOffline, onNetworkChange]);

  return { isOnline, wasOffline };
};

export default useNetworkStatus;
